// =============================================================================
// FILE:
// frontend/src/ipe/pms/components/site_store_dashboard/SiteStoreKpiCards.jsx
// =============================================================================

import React from "react";

import styles
  from "./siteStoreDashboardStyles";


// =============================================================================
// COMPONENT
// =============================================================================

export default function SiteStoreKpiCards({

  summaryData

}) {

  // ===========================================================================
  // KPI CARD
  // ===========================================================================

  const renderKpiCard = (

    title,
    value,
    color,
    icon

  ) => {

    return (

      <div
        style={{
          ...styles.kpiCard,
          borderTop:
            `4px solid ${color}`
        }}

        onMouseEnter={(e) => {

          e.currentTarget.style.transform =
            "translateY(-2px)";

          e.currentTarget.style.boxShadow =
            "0 8px 20px rgba(0,0,0,0.08)";
        }}

        onMouseLeave={(e) => {

          e.currentTarget.style.transform =
            "translateY(0px)";

          e.currentTarget.style.boxShadow =
            "0 1px 4px rgba(0,0,0,0.08)";
        }}
      >

        <div style={styles.kpiHeader}>

          <div style={styles.kpiTitle}>

            {title}

          </div>

          <div style={styles.kpiIcon}>

            {icon}

          </div>

        </div>

        <div style={styles.kpiValue}>

          {value}

        </div>

      </div>
    );
  };


  // ===========================================================================
  // RENDER
  // ===========================================================================

  return (

    <div style={styles.kpiGrid}>


      {
        renderKpiCard(

          "Current Stock",

          summaryData?.inventory
            ?.total_current_stock_qty || 0,

          "#2563eb",

          "📦"
        )
      }


      {
        renderKpiCard(

          "Available Stock",

          summaryData?.inventory
            ?.total_available_stock_qty || 0,

          "#16a34a",

          "🏭"
        )
      }


      {
        renderKpiCard(

          "Issued Qty",

          summaryData?.execution
            ?.total_issued_qty || 0,

          "#9333ea",

          "🚚"
        )
      }


      {
        renderKpiCard(

          "Consumed Qty",

          summaryData?.execution
            ?.total_consumed_qty || 0,

          "#0891b2",

          "🔧"
        )
      }


      {
        renderKpiCard(

          "Pending Qty",

          summaryData?.execution
            ?.total_pending_consumption_qty || 0,

          "#ea580c",

          "⏳"
        )
      }


      {
        renderKpiCard(

          "Low Stock",

          summaryData?.inventory
            ?.low_stock_material_count || 0,

          "#dc2626",

          "⚠️"
        )
      }

    </div>
  );
}